import { ClientContext } from "features/allocations/contexts/ClientContext";
import ClientDetail from "./ClientDetail";
import ClientHeader from "./ClientHeader";
import PropTypes from "prop-types";
import { useMemo } from "react";

const Client = ({ client, clientId, data, employee, opened }) => {
    
    const clientContextValue = useMemo(() => ({
        clientData: { client: client, clientId: clientId },
        projectsData: data,
    }), [client, clientId, data]);

    const handleToggleClick = () => {
        const divDetail = document.getElementById(`projects_${employee.userId}_${clientId}_${data[0].assignmentId}`);
        const divIco1 = document.getElementById(`ico1_client_${employee.userId}_${clientId}_${data[0].assignmentId}`);
        const divIco2 = document.getElementById(`ico2_client_${employee.userId}_${clientId}_${data[0].assignmentId}`);
        if (divDetail){
            if (divDetail.style.display === ""){
                divDetail.style.display = "none";
                if (divIco1 && divIco2){
                    divIco1.style.display = "none";
                    divIco2.style.display = "";
                }
            } else {
                divDetail.style.display = "";
                if (divIco1 && divIco2){
                    divIco1.style.display = "";
                    divIco2.style.display = "none";
                }
            }
        }
    }

    const assignmentId = data?.[0]?.assignmentId ?? 0;
    const headerId = `${employee.userId}_${clientId}_${assignmentId}`;
    const detailId = `projects_${employee.userId}_${clientId}_${assignmentId}`;

    return (
        <ClientContext.Provider value={clientContextValue}>
                <ClientHeader
                    name={client}
                    isOpen={opened}
                    onToggleClick={handleToggleClick}
                    id={headerId}
                />
                <div id={detailId} style={{display: opened ? "" : "none"}}>
                    <ClientDetail
                        data={data}
                        employee={employee}
                    />
                </div>
        </ClientContext.Provider>
    );
};

Client.propTypes = {
    client: PropTypes.string.isRequired,
    clientId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    data: PropTypes.array.isRequired,
    employee: PropTypes.shape({
        userId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    }).isRequired,
    opened: PropTypes.bool,
};

export default Client;
